/**
 * @license BCP
 * (c) 2015 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name auth
 * @description
 *
 * # auth
 *
 * The `auth` module provides authentication service.
 */

/**
 * @ngdoc service
 * @name auth
 *
 * @description
 * A factory which create a service to the client authentication.
 */
angular.module("auth", [])
  .factory("auth", function (b17Service, userCache) {

    var userData = {};
    var token;
    var client = userCache.get('resellerID') || 1;

    function checkUserData(currentToken) {
      return b17Service.loginInfo(currentToken).then(function (result) {
        if (result.data && result.data.data) {
          if (result.data.data.success) {
            userData = result.data.data.info;
            userData.FullName = userData.Name.First + 
              ' ' + userData.Name.Last;
              userData.Info = 'Info';
          } else {
            token = null;
            userData = {};
          }
        }
        return userData;
      });
    }

    return {

      loginUser: function (username, password) {
        return b17Service.login(username, password).then(function (answer) {
          if (answer.data && answer.data.data) {
            if (answer.data.data.success) {
              token = answer.data.data.token;
              return checkUserData(token);
            } else {
              token = null;
              userData = {};
              userData.error = answer.data.data.info;
            }
          }
          return userData;
        });
      },

      logoutUser: function () {
        b17Service.logout(token);
        token = null;
        userData = {};
      },

      checkUserData: function () {
        return checkUserData(token);
      },

      getUserData: function () {
        return userData;
      },

      getToken: function () {
        return token;
      },

      getClient: function () {
        return client;
      },

      setClient: function (id) {
        if (angular.isNumber(id) && id > 0) {
          client = id;
          userCache.put('resellerID', id);
        }
      }

    };
  })
  /**
 * @ngdoc directive
 * @name login
 *
 * @description
 * Login component which show current login status and the user identification
 */
.directive("login", function (auth) {
    return {
      restrict: "E",
      templateUrl: "components/auth/auth-panel.html",
      controller: function ($scope, $aside) {

        $scope.userData = function() {
          return auth.getUserData();
        };

        $scope.openAuth = function() {
          $aside.open({
            templateUrl: 'components/auth/login-form.html',
            placement: 'right',
            size: 'sm',
            backdrop: true,
            controller: 'loginFormCtrl'
          }).result.then(function (message) {
            console.log(message);
          });
        };
      } 
    };
  });

})();
